module.exports = __webpack_public_path__ + "assets/fa115a712cf8418e1df8490d88b75225.png";